import { MARK } from "../helper";

export abstract class TrackSessionStart {
  static setSended(value: boolean) {
    window.o_util.cookie.set("o_squirrel_sessionStart_sended", value + "");
  }

  static isSended(): boolean {
    return window.o_util.cookie.get("o_squirrel_sessionStart_sended") == "true";
  }

  static updateLabel(): number | undefined {
    let initialSearchBoxTime: number | undefined = undefined;
    const sessionStart = Number(window.o_util.cookie.get("o_squirrel_sessionStart"));
    const currentTime = new Date().getTime();
    const sessionTime = currentTime - sessionStart;
    const ttl = 7200000;
    if (sessionTime > ttl) {
      window.o_util.cookie.set("o_squirrel_sessionStart", performance.timing.navigationStart + "");
      this.setSended(false);
    }

    if (!this.isSended() && performance.getEntriesByName(MARK.INITIAL_SEARCH_BOX_TIME).length > 0) {
      initialSearchBoxTime = (performance.getEntriesByName(MARK.INITIAL_SEARCH_BOX_TIME).pop() as PerformanceEntry)
        .duration;
      this.setSended(true);
    }
    return initialSearchBoxTime;
  }
}

export const trackSessionStart = {
  setSended: TrackSessionStart.setSended,
  isSended: TrackSessionStart.isSended,
  updateLabel: TrackSessionStart.updateLabel,
};
